import { useEffect, useState } from "react";
import { CreditCard, CheckCircle2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";

export function StripeStatusCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/payments/status").then((r) => setS(r.data)).catch(() => setS(false)); }, []);
  if (s === null) return null;
  const live = s && s.mode === "live" && s.charges_enabled;
  const label = !s ? "Unavailable" : live ? "Live — taking real payments" : s.charges_enabled ? "Ready" : `Test mode`;
  return (
    <div className="dg-card rounded-xl p-5" data-testid="stripe-status-card">
      <div className="flex items-center gap-2">
        {live ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <AlertCircle className="w-4 h-4 text-amber-400" />}
        <div className="dg-eyebrow flex items-center gap-1"><CreditCard className="w-3 h-3" /> Payments (Stripe)</div>
        <span className={`dg-chip ml-auto ${live ? "text-emerald-300" : "text-amber-300"}`} data-testid="stripe-status-chip">{label}</span>
      </div>
      <p className="text-sm text-slate-400 mt-2">Customers book first and pay after the session through a secure Stripe link — sent automatically with your recap, or with the <strong className="text-slate-200">Send payment link</strong> button on any booking. Gift sessions are paid at checkout.</p>
      {!live && <p className="text-xs text-amber-200/90 mt-3" data-testid="stripe-claim-hint">Until you claim your Stripe account (Emergent → <strong>Manage → Payments</strong>), payments run in test mode: use card 4242 4242 4242 4242 to try it. Once claimed, live payments switch on by themselves.</p>}
      {s && <div className="text-xs text-slate-500 mt-3">Account country {s.country || "—"} · webhook {s.webhook_secret_set ? "connected" : "missing"}{s.error ? ` · ${s.error}` : ""}</div>}
    </div>
  );
}
